import { NotificationTypes } from 'constants/enums';

export const getId = (value: string, type: NotificationTypes) =>
  `${value}-${type}`;
